import React from 'react';
import {
  kycVerificationValidationConstants,
} from '../../../../utils/constants/kyc';
import { Markdown } from '../../../../shared/markdown';
import { Row } from '../../../../shared/Layout.styles';
import { Controller, useFormContext } from 'react-hook-form';
import Input from '../../../../shared/formElements/input';
import ControlledInput from '../../../../shared/formElements/controlledInput';
import AddressInput from '../../../../shared/formElements/addressInput';
import { CheckboxElement } from '../../../../shared/formElements/checkbox';

export const KycVerificationValidationInputs = () => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const {
    kycValidationSubText,
    consentText,
    cardIDSubText,
    defaultValue,
  } = kycVerificationValidationConstants;

  const buildStreetNumber = (street_number_1?: string, street_number_2?: string) => {
    if (street_number_2) {
      return `${street_number_1} ${street_number_2}`
    }
    return `${street_number_1}`
  }
  const buildStreetType = (street_type?: string, street_suffix?: string) => {
    if (street_suffix) {
      return `${street_type} ${street_suffix}`
    }
    return `${street_type}`
  }

  return (
    <>
      <Markdown children={kycValidationSubText} className="subText" />
      <Controller
        render={(props) => (
          <ControlledInput
            {...props}
            type="text"
            label="Unique Card ID or Activation Code*"
            fieldName="cardID"
            validation={errors?.cardID?.message}
            width="100%"
          />
        )}
        name="cardID"
        control={control}
        defaultValue={defaultValue.cardID || ''}
      />
      <Markdown children={cardIDSubText} className="subText" />
      <Controller
        render={(props) => (
          <ControlledInput
            {...props}
            type="text"
            label="Phone Number"
            fieldName="phoneNumber"
            validation={errors?.phoneNumber?.message}
            width="100%"
          />
        )}
        name="phoneNumber"
        control={control}
        defaultValue={defaultValue.phoneNumber || ''}
      />
      <div style={{width: '100%', height: '15px'}}></div>
      <Markdown children={"Date of Birth"} className="subText" />
      <Row>
        <Controller
          render={(props) => (
            <Input
              {...props}
              type="tel"
              label="Day*"
              fieldName="day"
              validation={errors?.day?.message}
              maxLength={2}
              width="25%"
            />
          )}
          name="day"
          control={control}
          defaultValue={defaultValue.day || ''}
        />
        <Controller
          render={(props) => (
            <Input
              {...props}
              type="tel"
              label="Month*"
              fieldName="month"
              validation={errors?.month?.message}
              maxLength={2}
              width="25%"
            />
          )}
          name="month"
          control={control}
          defaultValue={defaultValue.month || ''}
        />
        <Controller
          render={(props) => (
            <Input
              {...props}
              type="tel"
              label="Year*"
              fieldName="year"
              validation={errors?.year?.message}
              maxLength={4}
              width="50%"
            />
          )}
          name="year"
          control={control}
          defaultValue={defaultValue.year || ''}
        />
      </Row>
      <div style={{width: '100%', height: '15px'}}></div>
      <Markdown children={"Address"} className="subText" />
      <Controller
          render={(props) => (
            <AddressInput
              {...props}
              label="Full Address*"
              fieldName="fullAddress"
              validation={errors?.addressLine1?.message}
              onSelected={(fullAddress: any, addressData: any) => {
                setValue("flatNumber", addressData.unit_identifier || '');
                setValue("streetNumber",  buildStreetNumber(addressData.street_number_1, addressData.street_number_2) || '');
                setValue("streetName", addressData.street_name || '');
                setValue("streetType", buildStreetType(addressData.street_type, addressData.street_suffix) || '');
                setValue("suburb", addressData.locality_name || '');
                setValue("state", addressData.state_territory || '');
                setValue("postcode", addressData.postcode || '');
                setValue("country", addressData.country || '');
              }}
            />
          )}
          name="fullAddress"
          control={control}
          defaultValue=''
        />
      <Row>

        <Controller
          render={(props) => (
            <ControlledInput
              {...props}
              type="text"
              label="Unit/Flat Number"
              fieldName="flatNumber"
              validation={errors.flatNumber?.message}
              width="100%"
            />
          )}
          name="flatNumber"
          control={control}
          defaultValue={defaultValue.flatNumber}
        />
      <Controller
          render={(props) => (
            <ControlledInput
              {...props}
              type="text"
              label="Street Number"
              fieldName="streetNumber"
              validation={errors?.streetNumber?.message}
              width="100%"
            />
          )}
          name="streetNumber"
          control={control}
          defaultValue={defaultValue.streetNumber || ''}
        />
      <Controller
        render={(props) => (
          <ControlledInput
            {...props}
            type="text"
            label="Street Name"
            fieldName="streetName"
            validation={errors?.streetName?.message}
            width="100%"
          />
        )}
        name="streetName"
        control={control}
        defaultValue={defaultValue.streetName || ''}
      />

        <Controller
          render={(props) => (
            <ControlledInput
              {...props}
              type="text"
              label="Street Type"
              fieldName="streetType"
              validation={errors?.streetType?.message}
              width="100%"
            />
          )}
          name="streetType"
          control={control}
          defaultValue={defaultValue.streetType || ''}
        />
      </Row>
      <Row>
        <Controller
          render={(props) => (
            <ControlledInput
              {...props}
              disabled
              type="text"
              label="Suburb*"
              fieldName="suburb"
              validation={errors?.suburb?.message}
              width="100%"
            />
          )}
          name="suburb"
          control={control}
          defaultValue={defaultValue.suburb || ''}
        />
          <Controller
            render={(props) => (
              <ControlledInput
                {...props}
                disabled
                type="text"
                label="State*"
                fieldName="state"
                validation={errors?.state?.message}
                width="25%"
              />
            )}
            name="state"
            control={control}
            defaultValue={defaultValue.state || ''}
          />

          <Controller
            render={(props) => (
              <ControlledInput
                {...props}
                disabled
                type="text"
                label="Postcode*"
                fieldName="postcode"
                validation={errors?.postcode?.message}
                width="25%"
              />
            )}
            name="postcode"
            control={control}
            defaultValue={defaultValue.postcode || ''}
          />
          <Controller
            render={(props) => (
              <ControlledInput
                {...props}
                disabled
                type="text"
                label="Country*"
                fieldName="country"
                validation={errors?.country?.message}
                width="50%"
              />
            )}
            name="country"
            control={control}
            defaultValue={defaultValue.country || ''}
          />
        </Row>
      <CheckboxElement
        name="consentGranted"
        label={consentText}
        className="termsConditionsText"
        control={control}
        validation={errors?.consentGranted?.message}
      />
    </>
  );
};
